// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   MANAGE SERVER MODULE STYLES SHEET
   ========================================================================== */

.manage-server-dashboard-container {
  padding: 32px;
  background-color: #f8fafc;
  border-radius: 16px;
  min-height: 100vh;
  font-family: 'Inter', system-ui, sans-serif;
}

.manage-server-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 28px;
}

.manage-server-header-wrapper h2 {
  font-size: 24px;
  color: #0f172a;
  margin: 0 0 4px 0;
  font-weight: 700;
}

.manage-server-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

.km-back-btn {
  background-color: #ffffff;
  color: #1e293b;
  border: 1px solid #cbd5e1;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 150px; 
  transition: all 0.2s ease;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.km-back-btn:hover {
  background-color: #f1f5f9;
  color: #0f172a;
  border-color: #94a3b8;
  transform: translateX(-2px);
}

.manage-server-btn-refresh-global {
  display: inline-flex;
  align-items: center;
  width: 150px;
  gap: 8px;
  background-color: #ffffff;
  color: #475569;
  padding: 10px 18px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.manage-server-btn-refresh-global:hover {
  background-color: #f8fafc;
  color: #0f172a;
}

.manage-server-btn-icon {
  width: 16px;
  height: 16px;
}

/* CARDS GRID SYSTEM */
.manage-server-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 24px;
}

.manage-server-card {
  background: #ffffff;
  padding: 22px;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.manage-server-card h3 {
  font-size: 13px;
  color: #64748b;
  margin: 0 0 8px 0;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.manage-server-card p {
  font-size: 28px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
}

/* ADD SERVER SPECIAL CARD */
.manage-server-add-card {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
  border: none;
  cursor: pointer;
}
.manage-server-add-card h3 { color: #94a3b8; }
.manage-server-add-card p { color: #ffffff; font-size: 20px; font-weight: 600; margin-top: 4px;}
.manage-server-add-card:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.15); }

/* ACTIONS BAR SETUP */
.manage-server-table-actions-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  gap: 16px;
}

.manage-server-search-box-wrapper {
  position: relative;
  flex: 1 1;
  max-width: 480px;
}

.manage-server-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #94a3b8;
}

.manage-server-search-input {
  width: 100%;
  padding: 10px 14px 10px 40px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  font-size: 14px;
  background-color: #ffffff;
  box-sizing: border-box;
}

.manage-server-btn-create {
  display: inline-flex;
  align-items: center;
  width: 150px;
  gap: 8px;
  background-color: #0f172a;
  color: #ffffff;
  padding: 10px 20px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.manage-server-btn-create:hover { background-color: #1e293b; transform: translateY(-1px); }

/* RESPONISVE PRO TABLE PROFILE */
.manage-server-responsive-table-wrapper {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  overflow-x: auto;
}

.manage-server-pro-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-size: 14px;
}

.manage-server-pro-table th {
  background-color: #f8fafc;
  color: #475569;
  font-weight: 600;
  padding: 14px 20px;
  border-bottom: 1px solid #e2e8f0;
}

.manage-server-pro-table td {
  padding: 14px 20px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  vertical-align: middle;
}

.manage-server-text-bold {
  font-weight: 600;
  color: #0f172a;
}

.manage-server-name-text {
  font-weight: 600;
  color: #1e293b;
}

.manage-server-ip-block {
  background-color: #f8fafc;
  padding: 4px 8px;
  border-radius: 6px;
  font-family: monospace;
  color: #2563eb;
  border: 1px solid #e2e8f0;
  font-size: 13px;
}

.manage-server-location-badge {
  background-color: #f1f5f9;
  color: #334155;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  border: 1px solid #e2e8f0;
  font-weight: 500;
}

/* SERVER CONDITION PILLS */
.manage-server-status-badge {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  display: inline-block;
}
.manage-server-status-badge.online { background-color: #dcfce7; color: #15803d; }
.manage-server-status-badge.offline { background-color: #fee2e2; color: #b91c1c; }

/* ACTION ROW TRIGGERS */
.manage-server-table-row-actions {
  display: flex;
  gap: 6px;
  justify-content: center;
}

.manage-server-btn-row-action {
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.15s ease;
}

.manage-server-btn-edit { background-color: #f1f5f9; color: #334155; border-color: #cbd5e1; }
.manage-server-btn-delete { background-color: #fff5f5; color: #dc2626; }

.manage-server-btn-edit:hover { background-color: #e2e8f0; }
.manage-server-btn-delete:hover { background-color: #fee2e2; }

/* ERROR & SPINNER CHANNELS */
.manage-server-loading-spinner-wrapper, .manage-server-no-data-cell {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
}

.manage-server-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e2e8f0;
  border-top-color: #2563eb;
  border-radius: 50%;
  margin: 0 auto 16px auto;
  animation: srv-spin 0.8s linear infinite;
}

@keyframes srv-spin {
  to { transform: rotate(360deg); }
}

.manage-server-empty-state {
  padding: 20px 0;
}
.manage-server-empty-title {
  margin: 0 0 8px 0;
  font-weight: 500;
  color: #475569;
}
.manage-server-empty-desc {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
}`, "",{"version":3,"sources":["webpack://./src/components/KeyManage/ManageServer.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,4BAA4B;AAC5B;EACE,6DAA6D;EAC7D,YAAY;EACZ,eAAe;AACjB;AACA,6BAA6B,cAAc,EAAE;AAC7C,4BAA4B,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,eAAe,CAAC;AAC/F,gCAAgC,2BAA2B,EAAE,uCAAuC,EAAE;;AAEtG,sBAAsB;AACtB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA,kCAAkC,yBAAyB,EAAE,2BAA2B,EAAE;;AAE1F,iCAAiC;AACjC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;AACA,qCAAqC,yBAAyB,EAAE,cAAc,EAAE;AAChF,sCAAsC,yBAAyB,EAAE,cAAc,EAAE;;AAEjF,wBAAwB;AACxB;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA,0BAA0B,yBAAyB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC5F,4BAA4B,yBAAyB,EAAE,cAAc,EAAE;;AAEvE,gCAAgC,yBAAyB,EAAE;AAC3D,kCAAkC,yBAAyB,EAAE;;AAE7D,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB","sourcesContent":["/* ==========================================================================\n   MANAGE SERVER MODULE STYLES SHEET\n   ========================================================================== */\n\n.manage-server-dashboard-container {\n  padding: 32px;\n  background-color: #f8fafc;\n  border-radius: 16px;\n  min-height: 100vh;\n  font-family: 'Inter', system-ui, sans-serif;\n}\n\n.manage-server-header-wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 28px;\n}\n\n.manage-server-header-wrapper h2 {\n  font-size: 24px;\n  color: #0f172a;\n  margin: 0 0 4px 0;\n  font-weight: 700;\n}\n\n.manage-server-subtitle {\n  font-size: 14px;\n  color: #64748b;\n  margin: 0;\n}\n\n.km-back-btn {\n  background-color: #ffffff;\n  color: #1e293b;\n  border: 1px solid #cbd5e1;\n  padding: 8px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 150px; \n  transition: all 0.2s ease;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.km-back-btn:hover {\n  background-color: #f1f5f9;\n  color: #0f172a;\n  border-color: #94a3b8;\n  transform: translateX(-2px);\n}\n\n.manage-server-btn-refresh-global {\n  display: inline-flex;\n  align-items: center;\n  width: 150px;\n  gap: 8px;\n  background-color: #ffffff;\n  color: #475569;\n  padding: 10px 18px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.manage-server-btn-refresh-global:hover {\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.manage-server-btn-icon {\n  width: 16px;\n  height: 16px;\n}\n\n/* CARDS GRID SYSTEM */\n.manage-server-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.manage-server-card {\n  background: #ffffff;\n  padding: 22px;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  transition: all 0.2s ease;\n}\n\n.manage-server-card h3 {\n  font-size: 13px;\n  color: #64748b;\n  margin: 0 0 8px 0;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.manage-server-card p {\n  font-size: 28px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0;\n}\n\n/* ADD SERVER SPECIAL CARD */\n.manage-server-add-card {\n  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);\n  border: none;\n  cursor: pointer;\n}\n.manage-server-add-card h3 { color: #94a3b8; }\n.manage-server-add-card p { color: #ffffff; font-size: 20px; font-weight: 600; margin-top: 4px;}\n.manage-server-add-card:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0,0,0,0.15); }\n\n/* ACTIONS BAR SETUP */\n.manage-server-table-actions-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n  gap: 16px;\n}\n\n.manage-server-search-box-wrapper {\n  position: relative;\n  flex: 1;\n  max-width: 480px;\n}\n\n.manage-server-search-icon {\n  position: absolute;\n  left: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 16px;\n  height: 16px;\n  color: #94a3b8;\n}\n\n.manage-server-search-input {\n  width: 100%;\n  padding: 10px 14px 10px 40px;\n  border: 1px solid #cbd5e1;\n  border-radius: 10px;\n  font-size: 14px;\n  background-color: #ffffff;\n  box-sizing: border-box;\n}\n\n.manage-server-btn-create {\n  display: inline-flex;\n  align-items: center;\n  width: 150px;\n  gap: 8px;\n  background-color: #0f172a;\n  color: #ffffff;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 10px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.manage-server-btn-create:hover { background-color: #1e293b; transform: translateY(-1px); }\n\n/* RESPONISVE PRO TABLE PROFILE */\n.manage-server-responsive-table-wrapper {\n  background: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  overflow-x: auto;\n}\n\n.manage-server-pro-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  font-size: 14px;\n}\n\n.manage-server-pro-table th {\n  background-color: #f8fafc;\n  color: #475569;\n  font-weight: 600;\n  padding: 14px 20px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.manage-server-pro-table td {\n  padding: 14px 20px;\n  border-bottom: 1px solid #f1f5f9;\n  color: #334155;\n  vertical-align: middle;\n}\n\n.manage-server-text-bold {\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.manage-server-name-text {\n  font-weight: 600;\n  color: #1e293b;\n}\n\n.manage-server-ip-block {\n  background-color: #f8fafc;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-family: monospace;\n  color: #2563eb;\n  border: 1px solid #e2e8f0;\n  font-size: 13px;\n}\n\n.manage-server-location-badge {\n  background-color: #f1f5f9;\n  color: #334155;\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  border: 1px solid #e2e8f0;\n  font-weight: 500;\n}\n\n/* SERVER CONDITION PILLS */\n.manage-server-status-badge {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n  display: inline-block;\n}\n.manage-server-status-badge.online { background-color: #dcfce7; color: #15803d; }\n.manage-server-status-badge.offline { background-color: #fee2e2; color: #b91c1c; }\n\n/* ACTION ROW TRIGGERS */\n.manage-server-table-row-actions {\n  display: flex;\n  gap: 6px;\n  justify-content: center;\n}\n\n.manage-server-btn-row-action {\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  border: 1px solid transparent;\n  transition: all 0.15s ease;\n}\n\n.manage-server-btn-edit { background-color: #f1f5f9; color: #334155; border-color: #cbd5e1; }\n.manage-server-btn-delete { background-color: #fff5f5; color: #dc2626; }\n\n.manage-server-btn-edit:hover { background-color: #e2e8f0; }\n.manage-server-btn-delete:hover { background-color: #fee2e2; }\n\n/* ERROR & SPINNER CHANNELS */\n.manage-server-loading-spinner-wrapper, .manage-server-no-data-cell {\n  text-align: center;\n  padding: 60px 20px;\n  color: #64748b;\n}\n\n.manage-server-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  margin: 0 auto 16px auto;\n  animation: srv-spin 0.8s linear infinite;\n}\n\n@keyframes srv-spin {\n  to { transform: rotate(360deg); }\n}\n\n.manage-server-empty-state {\n  padding: 20px 0;\n}\n.manage-server-empty-title {\n  margin: 0 0 8px 0;\n  font-weight: 500;\n  color: #475569;\n}\n.manage-server-empty-desc {\n  margin: 0;\n  font-size: 13px;\n  color: #94a3b8;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
